export default class Kubernetes {
  client

  constructor(client) {
    this.client = client
  }

  /**
   * Get kubernetes stats
   * @param {Object} params - The pods overview parameters
   * @param {string} params.site_id - The site ID
   * @param {string} [params.from] - from timestamp
   * @param {string} [params.to] - to timestamp
   * @param {string} [params.namespaces] - Array of namespaces
   * @param {Object} [options={}] - Optional request options
   * @returns {Promise} The API response
   */
  podsOverview(params, options = {}) {
    return this.client.post("/api/v2/kubernetes/pods/overview", params, options)
  }

  /**
   * Get kubernetes pods
   * @param {Object} params - The pods parameters
   * @param {string} params.site_id - The site ID
   * @param {string} [params.from] - from timestamp
   * @param {string} [params.to] - to timestamp
   * @param {string} [params.namespaces] - Array of namespaces
   * @param {string} [params.node_name] - Node name
   * @param {string} [params.state] - Pod state
   * @param {string} [params.query] - Query
   * @param {Object} [options={}] - Optional request options
   * @returns {Promise} The API response
   */
  pods(params, options = {}) {
    return this.client.post("/api/v2/kubernetes/pods", params, options)
  }

  /**
   * Get kubernetes nodes
   * @param {Object} params - The nodes parameters
   * @param {string} params.site_id - The site ID
   * @param {string} [params.from] - from timestamp
   * @param {string} [params.to] - to timestamp
   * @param {string} [params.query] - Query
   * @param {Object} [options={}] - Optional request options
   * @returns {Promise} The API response
   */
  nodes(params, options = {}) {
    return this.client.post("/api/v2/kubernetes/nodes", params, options)
  }
}
